import { createContext, type ReactNode, useContext } from 'react';

export type IconSet = 'legacy' | 'uk';

const IconSetContext = createContext<IconSet>('legacy');

type IconSetProviderProps = {
  children: ReactNode;
  value: IconSet;
};

// Scoped to a React subtree rather than set globally: `Icon` is reached from generic primitives
// (SectionHeader, the nav accordion rows, both WrappedIcons) that deliberately carry no isUkStyle prop, and
// several of them also render in the desktop header. Only what a provider encloses can change.
export const IconSetProvider = ({ children, value }: IconSetProviderProps) => (
  <IconSetContext.Provider value={value}>{children}</IconSetContext.Provider>
);

export const useIconSet = () => useContext(IconSetContext);
